/**
 * This file holds the actions/mutations types
 * For more information about why this is needed
 * check here https://vuex.vuejs.org/guide/mutations.html#using-constants-for-mutation-types
 */
export const SET_TAB_CONTAINER_SIZE = "SET_TAB_CONTAINER_SIZE";

export const SET_GROUPS = "SET_GROUPS";
export const SET_SUBGROUPS = "SET_SUBGROUPS";
export const SET_GROUP_TABS = "SET_GROUP_TABS";
export const GET_GROUP_TABS = "GET_GROUP_TABS";
export const GET_SUBGROUP_TABS = "GET_SUBGROUP_TABS";

export const GET_AVAILABLE_SWATCHES_BY_COMPONENT =
  "GET_AVAILABLE_SWATCHES_BY_COMPONENT";
export const SET_AVAILABLE_SWATCHES_BY_COMPONENT =
  "SET_AVAILABLE_SWATCHES_BY_COMPONENT";

export const SET_TABS_SWATCHES_OBJECT_BY_COMPONENT =
  "SET_TABS_SWATCHES_OBJECT_BY_COMPONENT";
export const SET_AVAILABLE_TABS = "SET_AVAILABLE_TABS";

export const GET_PALETTES = "GET_PALETTES";
export const GET_PALETTE_MODAL_CONTENT = "GET_PALETTE_MODAL_CONTENT";
export const SET_PALETTES = "SET_PALETTES";
export const SET_PALETTES_BY_COMPONENT = "SET_PALETTES_BY_COMPONENT";
export const GET_AEM_MODAL_CONTENT = "GET_AEM_MODAL_CONTENT";

export const SET_TABS_SELECTED = "SET_TABS_SELECTED";
export const SET_SWATCHES_SELECTED = "SET_SWATCHES_SELECTED";
export const SET_HISTORY_SELECTED_TABS = "SET_HISTORY_SELECTED_TABS";

export const GET_RELATION_SWATCH_BY_SWATCH = "GET_RELATION_SWATCH_BY_SWATCH";
export const GET_RELATION_SWATCH_BY_RECIPE_ID = "GET_RELATION_SWATCH_BY_RECIPE_ID";
export const GET_RELATION_SWATCH_BY_FEATURE_ID = "GET_RELATION_SWATCH_BY_FEATURE_ID";

export const SET_SWATCHES_RELATION = "SET_SWATCHES_RELATION";
export const SET_EXCLUSIVE_SWATCHES = "SET_EXCLUSIVE_SWATCHES";

export const SET_DISABLED_SWATCHES_BY_FEATURE = "SET_DISABLED_SWATCHES_BY_FEATURE";
export const SET_PALETTES_ID = "SET_PALETTES_ID";

export const SET_PRODUCT_OPTION_TOGGLE = "SET_PRODUCT_OPTION_TOGGLE";

export const SET_EXCLUSIVE_COMPONENTS = "SET_EXCLUSIVE_COMPONENTS";

export const SET_LIST_SWATCHES_BY_COMPONENT = "SET_LIST_SWATCHES_BY_COMPONENT";

export const SET_SWATCHES_IN_PALETTES = "SET_SWATCHES_IN_PALETTES";

export const SET_PALETTE_THEME = "SET_PALETTE_THEME";

export const CLEAR_STATE_IN_TRANSFERING_DESIGN = "CLEAR_STATE_IN_TRANSFERING_DESIGN";

export const SET_PALETTES_HIDDEN_FEATURES = "SET_PALETTES_HIDDEN_FEATURES";

export const REMOVE_SELECTED_SWATCH = "REMOVE_SELECTED_SWATCH";

export const SET_SPLASH_TABS = "SET_SPLASH_TABS";

export const UPDATE_PALETTES_ID = "UPDATE_PALETTES_ID";

export const REMOVE_PALETTE = "REMOVE_PALETTE";

export const RESET_RELATION_BY_FEATURE = "RESET_RELATION_BY_FEATURE";
export const RESET_PALETTES_BY_COMPONENT = "RESET_PALETTES_BY_COMPONENT";